import _extends from 'babel-runtime/helpers/extends';
var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.node.visible ? _c('div', { class: 'node node-level-' + _vm.node.level, attrs: { "id": 'category-outline-' + _vm.node.id } }, [_vm.node.level !== 1 ? _c('div', { staticClass: "node-content", class: {
      'is-disabled': _vm.node.disabled,
      'is-current': _vm.node.id === _vm.currentNodeKey && (!_vm.activeCategoryNode.pid || _vm.activeCategoryNode.pid == _vm.node.pid)
    }, on: { "click": function click($event) {
        return _vm.$emit('node-click', _vm.node);
      } } }, [_vm.renderContent.render ? _c(_vm.renderContent, { tag: "component", attrs: { "node": _extends({}, _vm.node) } }) : _c('div', { staticClass: "node-label" }, [_vm._v(_vm._s(_vm.node.name))]), _vm._v(" "), _vm.hasChildren && !_vm.node.disabled ? _c('i', { staticClass: "icon-arrow-node", class: {
      'icon-arrow-down': _vm.node.isFold,
      'icon-arrow-up': !_vm.node.isFold
    }, staticStyle: { "padding": "3px 5px" }, on: { "click": function click(e) {
        _vm.$emit('fold-click', _vm.node);
        e.stopPropagation();
      } } }, [_c('span', { staticClass: "icon" })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.hasChildren && !_vm.node.isFold ? [_c('div', { staticClass: "node-children" }, _vm._l(_vm.node.sub_category, function (childNode) {
    return _c('node', _vm._g({ key: childNode.pid + '_' + childNode.id, attrs: { "node": childNode, "render-content": _vm.renderContent, "current-node-key": _vm.currentNodeKey } }, _vm.$listeners));
  }), 1)] : _vm._e()], 2) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };